import { render, staticRenderFns } from "./InventoryRequest.vue?vue&type=template&id=37e573d0&"
import script from "./InventoryRequest.vue?vue&type=script&lang=js&"
export * from "./InventoryRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports